import axios from 'axios'

export default {
    GETALLCHARITIES ({ commit }) {
        return axios.get('/charities').then((response) => {
            const { data: { data } } = response
            commit('setCharities', {charities: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETCHARITY ({ commit }, charityId) {
        return axios.get(`/charities/${charityId}`).then((response) => {
            const { data: { data } } = response
            commit('setCharity', {charity: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    SETSELECTEDCHARITY ({ commit }, info) {
        return axios.put(`/charities/updateByUserId/${info[0]}/${info[1]}`).then((response) => {
            const { data: { data } } = response
            commit('setSelectedCharity', {charity: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETSELECTEDCHARITY ({ commit }, userId) {
        return axios.get(`/charities/getByUserId/${userId}`).then((response) => {
            const { data: { data } } = response
            commit('setSelectedCharity', {charity: data})
        }, (err) => {
            console.log('err ', err)
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/charities/actions.js